export const BATCH_STATUS = [
    {
        name: 'Tất cả',
        value: '',
    },
    {
        name: 'Đang chờ',
        value: 'pending',
    },
    {
        name: 'Đang in',
        value: 'printing',
    },
    {
        name: 'Đã in',
        value: 'printed',
    },
    {
        name: 'Đã cắt',
        value: 'cut',
    },
    {
        name: 'Đã khắc',
        value: 'engraved',
    },
    {
        name: 'Đã hoàn thiện',
        value: 'improved',
    },
    // {
    //     name: 'Đang ép',
    //     value: 'transferring',
    // },
    // {
    //     name: 'Đã ép',
    //     value: 'transferred',
    // },
    // {
    //     name: 'QC sau ép',
    //     value: 'confirmed',
    // },
    // {
    //     name: 'Chờ may',
    //     value: 'wait_to_sew',
    // },
    // {
    //     name: 'Đang may',
    //     value: 'sewing',
    // },
    {
        name: 'Hoàn thành',
        value: 'completed',
    },
    {
        name: 'Đã ship',
        value: 'shipped',
    },
    {
        name: 'Hủy ship',
        value: 'cancel-ship',
    },
    {
        name: 'Đã move',
        value: 'moved',
    }
]
